function inferIconType(href: string): string | undefined {
  const cleanHref = href.split('?')[0]?.toLowerCase() ?? href.toLowerCase();
  if (cleanHref.endsWith('.svg')) return 'image/svg+xml';
  if (cleanHref.endsWith('.webp')) return 'image/webp';
  if (cleanHref.endsWith('.jpg') || cleanHref.endsWith('.jpeg')) return 'image/jpeg';
  if (cleanHref.endsWith('.png')) return 'image/png';
  // Some storage drivers transform GIF/other inputs to JPEG while preserving
  // the original URL suffix. Let the response Content-Type decide in that case.
  return undefined;
}

export function setAppFavicon(href: string): void {
  if (!href) return;

  let link = document.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = href;
  const type = inferIconType(href);
  if (type) link.type = type;
  else link.removeAttribute('type');
}
